const getCombinedIssueSelector = (combinedIssueSelector) => {
  if (!combinedIssueSelector)
    return JSON.parse(sessionStorage.getItem("combinedIssueSelector"));
  return combinedIssueSelector;
};

export const getProps = ({ combinedIssueSelector }) => {
  return {
    mvoenv: window.callJSON ? "development" : "prod",
    tier: window?.caseDetails?.tier,
    accountNumber: window?.caseDetails?.accountNumber,
    mdn: window?.caseDetails?.mtn,
    mtnId: window?.caseDetails?.mtnId,
    loggedInUser: window?.caseDetails?.userId,
    theme: {
      error: null,
      themeId: "theme_white",
      themeDescription: "Default - White",
      themeObject: {
        background: "#FFFFFF",
        textColor: "#000000",
        timeLineDotColor: "#4a4a4a",
        timeLineMarkerColor: "#d8d8d8",
        hoverLinkMenuColor: "#1466c6",
      },
      esbthemeId: "WHITE",
      isCallTimerOn: false,
      isCreateRemarksOn: false,
      overlayId: "33%",
      overlayDescription: "33%",
      overlayObject: {
        textColor: "black",
        backgroundDarkTheme: "rgba(0, 0, 0, 0.3)",
        backgroundWhiteTheme: "rgba(0, 0, 0, 0.3)",
      },
      menuthemeId: "White",
      menuthemeDescription: "White",
      menuthemeObject: {
        background: "#FFFFFF",
        textColor: "black",
        timeLineDotColor: "#4a4a4a",
        timeLineMarkerColor: "#d8d8d8",
        hoverLinkMenuColor: "#85beff",
      },
    },
    appId: window?.caseDetails?.appId,
    channel: window?._dg_channelId,
    channelId: window?._dg_channelId,
    mvoSolPortal: "https://solutionstest2.vzwcorp.com/portal/",
    externalTarget: window?.config?.externalTarget,
    equipmentId: window?.troubleShootingJson?.ddata?.device?.equipmentId,
    sku: window?.troubleShootingJson?.ddata?.device?.deviceSku,
    deviceId: window?.troubleShootingJson?.ddata?.device?.deviceId,
    deviceName: window?.troubleShootingJson?.ddata?.device?.deviceName,
    deviceType: "",
    oem: "",
    operatingSystem: "",
    billingSystem: "",
    token: window?.token?.token || "",
    combinedIssueSelector: getCombinedIssueSelector(combinedIssueSelector),
    changeDeviceFlow: window?.changeDeviceFlow,
  };
};
